/**
 * @sync-target レクシンユーザーメッセージ一覧 > 01_トースト通知一覧
 */
export const TOAST_MESSAGES = {
  AUTH: {
    FETCH_ORGANIZATION_FAILED: "組織情報の取得に失敗しました。再ログインしてください。",
    FETCH_USER_FAILED: "ユーザー情報の取得に失敗しました。再ログインしてください。",
    NO_JOINED_ORGANIZATION: "参加中の組織がありません。管理者に組織への招待を依頼してください。",
    INVALID_USER_DATA: "ユーザーデータが不正です。管理者に問い合わせてください。",
    FETCH_USER_DATA_FAILED: "ユーザーデータの取得に失敗しました。再ログインしてください。",
    SIGNIN_FAILED: "認証に失敗しました。再ログインしてください。",
    SIGNOUT_FAILED:
      "ログアウトに失敗しました。ブラウザを閉じるか、手動でログイン画面に遷移してください。",
    FETCH_USER_INFO_FAILED: "ユーザー情報が取得できませんでした。再ログインしてください。",
    FETCH_ORGANIZATION_INFO_FAILED: "組織情報が取得できませんでした。再ログインしてください。",
    FETCH_ORGANIZATION_ERROR: "組織情報の取得中にエラーが発生しました。再ログインしてください。",
  },
  SIGNUP: {
    DISPLAY_NAME_REQUIRED: "表示名フィールドは必須です。入力内容を修正してください。",
    SETUP_COMPLETED: "設定が完了しました",
    SAVE_FAILED: "設定の保存に失敗しました。再試行してください。",
    CREATE_FAILED: (errorMessage: string) => `作成に失敗しました: ${errorMessage}` as const,
  },
  PROJECT: {
    FETCH_PROJECTS_FAILED: "プロジェクトの取得に失敗しました。再ログインしてください。",
    CREATE_SUCCESS: "プロジェクトの作成に成功しました",
    CREATE_FAILED: "プロジェクトの作成に失敗しました。時間をおいて再試行してください。",
    INVALID_DATE_FORMAT: "無効な日付形式です。正しい日付を入力してください。",
    SAMPLE_HIDDEN: "サンプルプロジェクトを非表示にしました",
    RESELECT_PROJECT: "プロジェクトを再選択してください。",
    DELETE_SUCCESS: "プロジェクトを削除しました",
    UPDATE_SUCCESS: "プロジェクト情報の更新に成功しました",
    UPDATE_FAILED: "プロジェクト情報の更新に失敗しました。時間をおいて再試行してください。",
    INVALID_INPUT_FORMAT: "不正な入力形式です。入力内容を修正してください。",
  },
  ORGANIZATION: {
    FETCH_USER_FAILED: "ユーザー情報の取得に失敗しました。時間をおいて再試行してください。",
    NOT_MEMBER: "その組織に所属していません。管理者に組織への招待を依頼してください。",
    NOT_EXIST: "その組織は存在しません。URLを確認するか、管理者に問い合わせてください。",
    SELECTION_ERROR: "組織選択中にエラーが発生しました。時間をおいて再試行してください。",
    CHANGE_ROLE_SUCCESS: "ユーザー権限変更に成功しました",
    CHANGE_ROLE_FAILED: "ユーザー権限変更に失敗しました。管理者に権限付与を依頼してください。",
    DELETE_USER_SUCCESS: "ユーザー削除に成功しました",
    RESEND_INVITE_SUCCESS: "招待メールを再送信しました",
    INVITE_MEMBER_SUCCESS: "招待されたメンバーに招待メールを送信しました",
    INVITE_MEMBER_FAILED_WITH_PERIOD:
      "メンバー招待に失敗しました。入力内容を確認して再試行してください。",
    INVITE_MEMBER_FAILED: "メンバー招待に失敗しました。入力内容を確認して再試行してください。",
    INVITE_GUEST_SUCCESS: "招待されたゲストに招待メールを送信しました",
    INVITE_GUEST_FAILED: "ゲスト招待に失敗しました。入力内容を確認して再試行してください。",
  },
  PROJECT_MEMBER: {
    MISSING_INFO: "必要な情報が不足しています。ページを再読込してください。",
    CHANGE_ROLE_SUCCESS: "権限変更に成功しました",
    CHANGE_ROLE_FAILED: "権限変更に失敗しました。管理者に権限付与を依頼してください。",
    DELETE_USER_SUCCESS: "ユーザー削除に成功しました",
    DELETE_USER_FAILED: "ユーザー削除に失敗しました。再試行してください。",
    FETCH_INVITABLE_USERS_FAILED:
      "招待可能なユーザーの取得に失敗しました。時間をおいて再試行してください。",
    PROJECT_NOT_SELECTED: "プロジェクトが選択されていません。プロジェクトを選択してください。",
    USER_NOT_FOUND: "ユーザー情報が見つかりません。対象の存在を確認してください。",
    SELECT_MEMBER: "追加するメンバーを選択してください。",
    ADD_MEMBER_SUCCESS: "メンバー追加リクエストを送信しました。",
    ADD_MEMBER_FAILED: "メンバーの追加に失敗しました。時間をおいて再試行してください。",
    FETCH_INVITABLE_USERS_ERROR:
      "招待可能なユーザーの取得中にエラーが発生しました。入力内容を確認して再試行してください。",
  },
  GENERATION: {
    MINUTES_REQUEST_SUCCESS: "議事録の生成リクエストに成功しました",
    MINUTES_REQUEST_FAILED:
      "議事録の生成リクエストに失敗しました。時間をおいて再試行してください。",
    SYSTEM_OVERVIEW_REQUEST_SUCCESS: "システム概要書の生成リクエストに成功しました",
    ESTIMATION_REQUEST_SUCCESS: "概算工数見積もりの生成リクエストに成功しました",
    FUNC_REQUIREMENT_REQUEST_SUCCESS: "機能要件書の生成リクエストに成功しました",
    NON_FUNC_REQUIREMENT_REQUEST_SUCCESS: "非機能要件書の生成リクエストに成功しました",
    WORKFLOW_REQUEST_SUCCESS: "業務フロー図の生成リクエストに成功しました",
    PLUGIN_REQUEST_SUCCESS: "プラグイン提案書の生成リクエストに成功しました",
    APP_DESIGN_REQUEST_SUCCESS: "アプリ設計書の生成リクエストに成功しました",
    FIELD_DESIGN_REQUEST_SUCCESS: "フィールド設計書の生成リクエストに成功しました",
    ER_DIAGRAM_REQUEST_SUCCESS: "ER図の生成リクエストに成功しました",
    SYSTEM_ARCHITECTURE_REQUEST_SUCCESS: "システム構成図の生成リクエストに成功しました",
    CUSTOMIZE_SPEC_REQUEST_SUCCESS: "カスタマイズ仕様書の生成リクエストに成功しました",
    COMPLETE: (docName: string) => `${docName}の生成が完了しました` as const,
    UNKNOWN_ERROR: "不明なエラーが発生しました。時間をおいて再試行してください。",
    FIELD_DESIGN_NOT_GENERATED:
      "フィールド設計書は生成されていません。トップページから生成してください。",
    PLAN_NOT_AVAILABLE: "現在のプランではご利用できません。プランをアップグレードしてください。",
    ESTIMATION_GENERATING: "概算工数見積もりは生成中です",
    ESTIMATION_NOT_GENERATED:
      "概算工数見積もりは生成されていません。トップページから生成してください。",
    DOCUMENT_GENERATING: (title: string) => `${title}は生成中です` as const,
    DOCUMENT_NOT_GENERATED: (title: string) =>
      `${title}は生成されていません。トップページから生成してください。` as const,
    ESTIMATION_REQUIRED: "概算工数見積もりを先に生成してください",
    ALREADY_GENERATING: "すでに生成中です。時間をおいて再度実行してください。",
  },
  SUMMARY: {
    NOT_FOUND: "議事録が見つかりません。対象の存在を確認してください。",
    NAME_EMPTY: "議事録名は空にできません。議事録名を入力してください。",
    UNKNOWN_ERROR: "不明なエラーが発生しました。時間をおいて再試行してください。",
    NOT_GENERATED: "議事録が未生成です。\nトップページから生成してください。",
    NOT_SELECTED: "議事録が選択されていません。議事録を選択してください。",
    FETCH_FAILED: "議事録を取得できませんでした。時間をおいて再試行してください。",
    LOCK_FAILED: "編集権限を取得できませんでした。時間をおいて再試行してください。",
    FETCH_PROJECT_FAILED: "プロジェクトを取得できませんでした。時間をおいて再試行してください。",
    NAME_REQUIRED: "名前は必須です。入力内容を修正してください。",
    INVALID_FILE_FORMAT:
      "許可されたファイル形式はテキスト、マークダウン、Word(docx)のみです。対応ファイル形式に変換してアップロードしてください。",
    ALL_FILES_FAILED:
      "すべてのファイルの処理に失敗しました。対応ファイル形式に変換してアップロードしてください。",
    UNEXPECTED_ERROR: "予期しないエラーが発生しました。時間をおいて再試行してください。",
    NO_FILE_SELECTED:
      "ファイルが選択されませんでした。ファイルを選択してアップロードしてください。",
    INVALID_FILE_TYPE: (fileName: string) =>
      `許可されていないファイル形式です: ${fileName}` as const,
    MAX_CHAR_EXCEEDED: (maxCharLimit: number) =>
      `最大文字数（${maxCharLimit}字）を超えています` as const,
    GENERATE_REQUEST_SUCCESS: "議事録の生成リクエストに成功しました",
  },
  ESTIMATION: {
    NOT_GENERATED: "概算工数見積書が未生成です。\nトップページから生成してください。",
    NOT_FOUND: "概算工数見積書が見つかりません。対象の存在を確認してください。",
    LOAD_FAILED: "概算工数見積書の読み込みに失敗しました。時間をおいて再試行してください。",
    FETCH_DOCUMENT_FAILED: "ドキュメントの取得に失敗しました。時間をおいて再試行してください。",
    CONFIRM_SUCCESS: "見積もりを確定しました",
    UPDATE_SELECTION_FAILED: "選択状態の更新に失敗しました。時間をおいて再試行してください。",
    UPDATE_ERROR: "更新中にエラーが発生しました。時間をおいて再試行してください。",
  },
  COST_EFFECTIVENESS: {
    ESTIMATION_NOT_GENERATED: "概算工数見積書が未生成です。\n概算工数ページで生成してください。",
    UPDATE_SUCCESS: "設定を更新しました。",
    CHART_NOT_FOUND: "チャートが見つかりません。ページを再読込してください。",
    SVG_NOT_FOUND: "SVG要素が見つかりません。ページを再読込してください。",
    EXPORT_SUCCESS: "グラフをエクスポートしました",
    IMAGE_GENERATION_FAILED: "画像の生成に失敗しました。時間をおいて再試行してください。",
    INVALID_INPUT: "入力値が無効です。半角数字で入力してください。",
  },
  DOCUMENT: {
    APP_DESIGN_NOT_GENERATED:
      "アプリ設計書は生成されていません。トップページから生成してください。",
    PROJECT_LOAD_FAILED:
      "プロジェクトデータの読み込みに失敗しました。時間をおいて再試行してください。",
    FIELD_DESIGN_NOT_FOUND: "フィールド設計書が見つかりません。対象の存在を確認してください。",
    FIELD_DESIGN_NOT_GENERATED:
      "フィールド設計書は生成されていません。トップページから生成してください。",
    CUSTOMIZE_SPEC_NOT_FOUND: "カスタマイズ仕様書が見つかりません。対象の存在を確認してください。",
    NAVIGATION_ERROR_ID_NOT_FOUND:
      "ナビゲーションエラー: 必要なIDが見つかりません。対象の存在を確認してください。",
    PLUGIN_NOT_FOUND: "プラグイン提案書が見つかりません。対象の存在を確認してください。",
    FUNC_REQUIREMENT_NOT_GENERATED:
      "機能要件書は生成されていません。トップページから生成してください。",
    NON_FUNC_REQUIREMENT_NOT_GENERATED:
      "非機能要件書は生成されていません。トップページから生成してください。",
    EDIT_CANCEL_SUCCESS: "編集をキャンセルしました。",
    EDIT_CANCEL_FAILED: "編集のキャンセルに失敗しました。時間をおいて再試行してください。",
    CANCEL_ERROR: "キャンセル処理中にエラーが発生しました。時間をおいて再試行してください。",
    SYSTEM_ARCHITECTURE_NOT_GENERATED:
      "システム構成図は生成されていません。トップページから生成してください。",
    SYSTEM_ARCHITECTURE_NOT_FOUND: "システム構成図が見つかりません。対象の存在を確認してください。",
    SYSTEM_ARCHITECTURE_LOAD_FAILED:
      "システム構成図の読み込みに失敗しました。時間をおいて再試行してください。",
    SAVE_TARGET_NOT_FOUND: "保存先のドキュメントが見つかりません。対象の存在を確認してください。",
    SAVE_FAILED: "保存に失敗しました。再試行してください。",
    UNLOCK_FAILED: "ロックの解除に失敗しました。時間をおいて再試行してください。",
    ER_DIAGRAM_NOT_FOUND: "ER図が見つかりません。対象の存在を確認してください。",
    ER_DIAGRAM_FETCH_FAILED: "ER図の取得に失敗しました。時間をおいて再試行してください。",
    ER_NAVIGATION_ERROR:
      "ナビゲーションエラー: 組織IDまたはプロジェクトIDが見つかりません。対象の存在を確認してください。",
    ER_SAVE_FAILED: "ER図の保存に失敗しました。再試行してください。",
    WORKFLOW_NOT_FOUND: "ワークフロー図が見つかりません。対象の存在を確認してください。",
    WORKFLOW_FETCH_FAILED: "業務フロー図の取得に失敗しました。時間をおいて再試行してください。",
    WORKFLOW_SAVE_FAILED: "業務フロー図の保存に失敗しました。再試行してください。",
    SYSTEM_ARCHITECTURE_SAVE_FAILED: "システム構成図の保存に失敗しました。再試行してください。",
    CUSTOMIZE_SPEC_SAVE_INFO_MISSING:
      "保存に必要な情報が不足しています。時間をおいて再試行してください。",
    DELETE_SUCCESS: "ドキュメントの削除に成功しました",
  },
  DRAWIO: {
    LOCK_FAILED: "編集権限を取得できませんでした。時間をおいて再試行してください。",
    ERROR: "エラーが発生しました。時間をおいて再試行してください。",
    REF_NOT_FOUND: "DrawIoの参照が見つかりません。ページを再読込してください。",
    EXPORT_SUCCESS: "エクスポートに成功しました",
    EXPORT_DATA_NOT_FOUND: "エクスポートデータが見つかりません。再試行してください。",
    SVG_EXPORT_FAILED: "SVGエクスポートに失敗しました。再試行してください。",
    SAVE_FAILED: "保存に失敗しました。再試行してください。",
  },
  EXPORT: {
    SUCCESS: "エクスポートに成功しました",
    MISSING_INFO: "エクスポートに必要な情報が不足しています。再試行してください。",
    ERROR: "エクスポート処理中にエラーが発生しました。再試行してください。",
    XML_NOT_FOUND: "XMLデータが見つかりません。図面を再読込してから再試行してください。",
    PNG_BASE64_ERROR:
      "PNGエクスポートに失敗しました: Base64処理エラー。再試行してください。継続する場合は管理者へ連絡してください。",
    PNG_NO_DATA: "PNG形式に変換できるデータがありません。再試行してください。",
    PNG_FAILED: "PNGエクスポートに失敗しました。再試行してください。",
    TARGET_NOT_FOUND: "エクスポート対象が見つかりません。再試行してください。",
    PDF_SUCCESS: "PDFエクスポートに成功しました",
    PDF_FAILED: "PDFエクスポートに失敗しました。再試行してください。",
    SVG_BASE64_ERROR:
      "SVGエクスポートに失敗しました: Base64処理エラー。再試行してください。継続する場合は管理者へ連絡してください。",
    SVG_XML_ERROR:
      "SVGエクスポートに失敗しました: XML処理エラー。図面を再読込してから再試行してください。",
    SVG_FAILED: "SVGエクスポートに失敗しました。再試行してください。",
  },
  APP_DEVELOPMENT: {
    OLD_DOCUMENT_ERROR:
      "2026年4月14日以前に生成されたドキュメントでは\nアプリ生成ができません。\nアプリ設計書/フィールド設計書/カスタマイズ仕様書の作成日を確認してください。",
    REGENERATE_DOCUMENT: "ドキュメントを再生成してください",
    START_SUCCESS: "アプリ生成を開始しました",
    START_FAILED: (errorMessage: string) =>
      `アプリ生成の開始に失敗しました: ${errorMessage}` as const,
    GENERATION_FAILED: "アプリ生成に失敗しました。時間をおいて再試行してください。",
    GENERATION_FAILED_WITH_REASON: (reason: string) =>
      `アプリ生成に失敗しました: ${reason}` as const,
    GENERATION_COMPLETE: "アプリ生成が完了しました",
    ABORT_SUCCESS: "アプリ生成を中止しました",
    ABORT_FAILED: "アプリ生成の中止に失敗しました。時間をおいて再試行してください。",
    DOWNLOAD_FAILED: "ファイルのダウンロードに失敗しました。時間をおいて再試行してください。",
    CODE_COPIED: "コードをコピーしました",
    NETWORK_ERROR: "接続に失敗しました。ネットワーク接続を確認してください。",
    AUTH_FAILED: "ログイン名またはパスワードが正しくありません。入力内容を確認してください。",
    PERMISSION_DENIED:
      "スペースの作成やアプリの管理権限が不足しています。必要な権限を持つアカウント情報を入力してください。",
    SUBDOMAIN_NOT_FOUND: "サブドメインが見つかりません。正しいサブドメインを入力してください。",
    CONNECTION_TIMEOUT: "接続がタイムアウトしました。しばらく待ってから再試行してください。",
    RATE_LIMITED: "アクセス制限中です。しばらく待ってから再試行してください。",
    UNEXPECTED_ERROR: "予期しないエラーが発生しました。しばらく待ってから再試行してください。",
    PROJECT_INFO_NOT_FOUND: "プロジェクト情報が取得できません。時間をおいて再試行してください。",
  },
  KINTONE_ADMIN: {
    REGISTER_FAILED: "登録に失敗しました。時間をおいて再試行してください。",
  },
  REVERSE_ENGINEERING: {
    FETCH_REPORTS_FAILED: "レポートの取得に失敗しました。時間をおいて再試行してください。",
    DELETE_MISSING_INFO:
      "削除に必要な情報が不足しています。ページを再読込してから再試行してください。",
    DELETE_SUCCESS: "レポートを削除しました。",
    DELETE_FAILED: "レポートの削除に失敗しました。再試行してください。",
    BACKGROUND_PROCESSING: "リバースエンジニアリングはバックグラウンドで進行しています",
    REPORT_NOT_FOUND: "レポートデータが見つかりません。対象の存在を確認してください。",
    FETCH_REPORT_FAILED: "レポートの取得に失敗しました。時間をおいて再試行してください。",
    HISTORY_PREPARING: "履歴機能は準備中です",
    PROJECT_INFO_MISSING:
      "プロジェクト情報が不足しています。プロジェクトを選択してから再試行してください。",
    DETAIL_ANALYSIS_STARTED: "詳細分析を開始しました",
    ANALYSIS_START_FAILED: "分析の開始に失敗しました。時間をおいて再試行してください。",
    ANALYSIS_START_ERROR: "分析の開始中にエラーが発生しました。時間をおいて再試行してください。",
    AUTH_SUCCESS: "認証に成功しました",
    AUTH_FAILED: "認証に失敗しました。認証情報を確認してください。",
    AUTH_ERROR: "認証中にエラーが発生しました。時間をおいて再試行してください。",
    PREPARATION_FAILED: "準備処理に失敗しました。時間をおいて再試行してください。",
    PREPARATION_ERROR: "準備処理中にエラーが発生しました。時間をおいて再試行してください。",
    REPORT_CREATED: "レポートを作成しました",
    REPORT_NAME_UPDATED: "レポート名を更新しました",
    REPORT_NAME_UPDATE_FAILED: "レポート名の更新に失敗しました。時間をおいて再試行してください。",
    REPORT_NAME_REQUIRED: "レポート名を入力してください",
    USER_INFO_MISSING: "ユーザー情報が不足しています。再ログインしてください。",
    STEP_PROCESSING_FAILED: "処理に失敗しました。一覧画面で状態を確認してください。",
    DEPENDENCY_ANALYSIS_FAILED: "依存関係の解析に失敗しました。時間をおいて再試行してください。",
    DEPENDENCY_ANALYSIS_COMPLETE: "依存関係の解析が完了しました",
    RE_FAILED: "リバースエンジニアリングが失敗しました。時間をおいて再試行してください。",
    TIMEOUT:
      "処理がタイムアウトしました（3分）。一覧画面で状態を確認し、必要に応じて再実行してください。",
  },
  KNOWLEDGE: {
    ACTIVATED: "有効にしました",
    ACTIVATE_FAILED: "有効化に失敗しました。時間をおいて再試行してください。",
    STATUS_CHANGED: (statusText: string) => `ナレッジを${statusText}にしました。` as const,
    STATUS_UPDATE_FAILED: "状態の更新に失敗しました。時間をおいて再試行してください。",
    STATUS_UPDATE_ERROR: "状態の更新中にエラーが発生しました。時間をおいて再試行してください。",
    REQUIRED_FIELDS: "必須項目を入力してください",
    UPDATED: "ナレッジが更新されました",
    CREATED: "ナレッジが作成されました",
    ACTIVATE_AFTER_SAVE_FAILED:
      "有効化に失敗しました。ナレッジは保存されています。時間をおいて再試行してください。",
    APPROVAL_ERROR: "承認中にエラーが発生しました。時間をおいて再試行してください。",
    ACTIVATE_ERROR: "有効化中にエラーが発生しました。時間をおいて再試行してください。",
    CANDIDATE_DISCARDED: "ナレッジ候補を破棄しました。",
    ALL_CANDIDATES_PROCESSED: "すべてのナレッジ候補を処理しました。",
    DISCARD_ERROR: "破棄中にエラーが発生しました。時間をおいて再試行してください。",
    DELETE_SUCCESS: "ナレッジを削除しました。",
    DELETE_FAILED: "削除に失敗しました。再試行してください。",
    DELETE_ERROR: "削除中にエラーが発生しました。時間をおいて再試行してください。",
    APPROVAL_FAILED: "承認に失敗しました。時間をおいて再試行してください。",
    UPDATE_FAILED: "ナレッジの更新に失敗しました。時間をおいて再試行してください。",
    STATUS_UPDATE_FAILED_API: "状態の更新に失敗しました。時間をおいて再試行してください。",
  },
  AI_CHAT: {
    ORGANIZATION_NOT_FOUND: "組織情報が見つかりません。再ログインしてください。",
    CREDIT_UPDATE_FAILED: "クレジット情報の更新に失敗しました。再試行してください。",
    STRUCTURED_DIFF_PARSE_FAILED:
      "AIが生成したドキュメントの形式が不正なため、差分を表示できません。再度お試しください。",
  },
  LAYOUT: {
    FETCH_USER_FAILED: "ユーザー情報が取得できませんでした。再ログインしてください。",
    FETCH_ORGANIZATION_FAILED: "組織情報が取得できませんでした。再ログインしてください。",
    FETCH_ORGANIZATION_ERROR: "組織情報の取得中にエラーが発生しました。再ログインしてください。",
    FETCH_NOTIFICATIONS_FAILED: "お知らせの取得に失敗しました。ページを再読込してください。",
    CREDIT_ORGANIZATION_NOT_FOUND: "組織情報が見つかりません。再ログインしてください。",
    CREDIT_UPDATE_FAILED: "クレジット情報の更新に失敗しました。再試行してください。",
    SIDEBAR_GENERATING: (itemName: string) => `${itemName}は生成中です` as const,
    SIDEBAR_NOT_GENERATED: (itemName: string) =>
      `${itemName}は生成されていません。トップページから生成してください。` as const,
  },
  USER_SETTINGS: {
    CHAR_LIMIT_EXCEEDED: "入力された文字数が制限を超えています。入力文字数を減らしてください。",
    SAVE_SUCCESS: "保存に成功しました",
    CURRENT_PASSWORD_REQUIRED: "現在のパスワードを入力してください",
    PASSWORD_REQUIREMENTS_NOT_MET:
      "パスワード要件を満たしていません。大文字/小文字/数字/記号を含む8文字以上のパスワードを入力してください。",
    PASSWORD_MISMATCH: "新しいパスワードが一致しません。同じパスワードを再入力してください。",
  },
  BILLING: {
    CREDIT_UPDATE_SUCCESS: "クレジット情報を更新しました",
    CREDIT_UPDATE_FAILED: "クレジット情報の更新に失敗しました。再試行してください。",
    APP_GENERATION_UPDATE_SUCCESS: "アプリ生成利用回数を更新しました",
    APP_GENERATION_UPDATE_FAILED: "アプリ生成利用回数の更新に失敗しました。再試行してください。",
    CHAT_REQUEST_UPDATE_SUCCESS: "チャットリクエストを更新しました",
    CHAT_REQUEST_UPDATE_FAILED: "チャットリクエストの更新に失敗しました。再試行してください。",
    CHAT_REQUEST_ADD_SUCCESS: "チャットリクエストの追加に成功しました",
    CHAT_REQUEST_ADD_FAILED: "チャットリクエストの追加に失敗しました。再試行してください。",
    UNEXPECTED_ERROR: "予期しないエラー。時間をおいて再試行してください。",
  },
  ROUTING: {
    ORGANIZATION_MISMATCH: "組織が一致しません。正しい組織でログインし直してください。",
    PROJECT_NOT_FOUND:
      "プロジェクトが見つかりません。プロジェクト一覧から正しいプロジェクトを選択してください。",
    PROJECT_LOAD_FAILED: "プロジェクトの読み込みに失敗しました。時間をおいて再試行してください。",
  },
  HISTORY: {
    DOCUMENT_NOT_GENERATED: (documentName: string) =>
      `${documentName}は生成されていません。トップページから生成してください。` as const,
    DOCUMENT_NOT_FOUND: (documentName: string) =>
      `${documentName}が見つかりません。対象の存在を確認してください。` as const,
    UNKNOWN_DOCUMENT_TYPE: "不明なドキュメントタイプ。管理者に問い合わせてください。",
    RESTORE_SUCCESS: "ドキュメントの復元に成功しました",
    RESTORE_FAILED: "ドキュメントの復元に失敗しました。再試行してください。",
    ER_NOT_EXIST: "ER図が存在しません。一覧に戻って再度選択してください。",
    ER_LOAD_FAILED: "ER図の読み込みに失敗しました。時間をおいて再試行してください。",
    SYSTEM_ARCHITECTURE_NOT_EXIST:
      "システム構成図が存在しません。一覧に戻って再度選択してください。",
    SYSTEM_ARCHITECTURE_LOAD_FAILED:
      "システム構成図の読み込みに失敗しました。時間をおいて再試行してください。",
    WORKFLOW_NOT_EXIST: "業務フロー図が存在しません。一覧に戻って再度選択してください。",
    WORKFLOW_LOAD_FAILED: "業務フロー図の読み込みに失敗しました。時間をおいて再試行してください。",
  },
  PUSH_NOTIFICATION: {
    BROWSER_NOT_SUPPORTED:
      "このブラウザはプッシュ通知をサポートしていません。プッシュ通知対応ブラウザ（Chrome/Edge/Firefox等）をご利用ください。",
  },
  TUTORIAL: {
    CLOSE_DISABLED: "サンプル動作：閉じる操作は無効です",
    CHAT_HISTORY_LOADED: "サンプル動作：チャット履歴を読み込みました",
    HISTORY_RELOAD_DUMMY: "サンプル動作：履歴の再読み込みはダミーです",
    CREDIT_UPDATE_DUMMY: "サンプル動作：クレジット情報の更新はダミーです",
    KNOWLEDGE_ADD_DISABLED: "サンプル動作：ナレッジの新規追加はチュートリアルでは利用できません",
    MINUTES_UPLOADED: "サンプル動作：議事録をアップロードしました",
    STEP1_REQUIRED: "STEP1の議事録を先に生成してください。",
    SYSTEM_OVERVIEW_SUCCESS: "サンプル動作：システム概要書の生成に成功しました",
    STEP2_REQUIRED: "STEP2のシステム概要書を先に生成してください。",
  },
} as const;
